import { GROUPED_VIOLATION_SUBTYPES, VIOLATION_TYPES } from '../../constants/reports/violationReports.constants';
const getViolationKey = (violation) => {
  if (violation.details?.break) return GROUPED_VIOLATION_SUBTYPES.breakViolations;
  if (violation.type.subType === VIOLATION_TYPES.SHIFT && violation.type.type === VIOLATION_TYPES.MISSED) {
    return GROUPED_VIOLATION_SUBTYPES.missedShifts;
  }
  return GROUPED_VIOLATION_SUBTYPES.clockViolations;
};

export const groupViolationsByType = (violations) => {
  if (!violations || violations.length === 0) {
    return {
      TOTAL: 0,
      ALL: {
        title: 'ALL',
        count: 0,
        items: [],
      },
    };
  }

  const grouped = {
    TOTAL: violations.length,
    ALL: {
      title: 'ALL',
      count: 0,
      items: [],
    },
  };

  violations.forEach((violation) => {
    if (!violation.type?.message) return;

    const key = getViolationKey(violation);

    if (!grouped[key]) {
      grouped[key] = {
        title: key,
        count: 0,
        items: [],
      };
    }

    grouped[key].items.push(violation);
    grouped[key].count += 1;

    // También agregar al grupo ALL
    grouped.ALL.items.push(violation);
    grouped.ALL.count += 1;
  });

  return grouped;
};

// Optimized function to add employee information to violations
export const getViolationsWithEmployeeInfo = (violations, employees) => {
  // Return an empty array if there are no violations or employees
  if (!violations?.length || !employees?.length) {
    return [];
  }

  // Create the employee map only once
  const employeeMap = new Map(
    employees.map(({ id, displayName, profileImageUrl }) => [id, { displayName, profileImageUrl }])
  );

  // Use map instead of reduce to improve readability and avoid creating a new array
  // Filter afterward to remove undefined elements (when the employee is not found)
  return violations
    .map((violation) => {
      const employeeInfo = employeeMap.get(violation.eid);
      if (!employeeInfo) return null; // Return null if the employee is not found

      // Use Object.assign to improve performance when merging objects
      return Object.assign({}, violation, employeeInfo);
    })
    .filter(Boolean); // Remove null elements
};

// Get the nested value of an object
export const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

// Sort the violations based on the selected column
export const descendingComparator = (a, b, orderBy) => {
  const valueA = getNestedValue(a, orderBy);
  const valueB = getNestedValue(b, orderBy);

  if (valueB < valueA) return -1;
  if (valueB > valueA) return 1;
  return 0;
};

// Get the comparator based on the selected column
export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

// Sort the violations based on the selected column
export const stableSort = (array, comparator) => {
  const stabilizedArray = array.map((el, index) => [el, index]);
  stabilizedArray.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedArray.map((el) => el[0]);
};
